let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8gQKz"), load("ctZCD"), load("8DoxJ"), load("joJy8"), load("aHE9G"), load("gopxm")]).then(() => parcelRequire('1BKEb'));